import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import HRAMain from '../components/hra/HRAMain';

const HRAPage = () => {
  const { user, isAuthenticated, verifyAuth } = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      if (!isAuthenticated) {
        // Try to verify existing token
        const hasValidToken = await verifyAuth();
        if (!hasValidToken) {
          // Not authenticated, redirect to scan page for authentication
          // Store the intended destination so we can redirect back after auth
          sessionStorage.setItem('redirectAfterAuth', '/hra');
          navigate('/scan');
        }
      }
    };
    checkAuth();
  }, [isAuthenticated, verifyAuth, navigate]);

  // Show loading or redirect if not authenticated
  if (!isAuthenticated) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Redirecting to authentication...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <HRAMain user={user} />
    </div>
  );
};

export default HRAPage;
